package music.jammers.client.shared.component

import androidx.compose.runtime.MutableState

fun <T> MutableState<T>.update(block: T.() -> T) {
    val current = value
    value = current.block()
}